(() => {
  if (window.productDesignTabsLoaded) return;
  window.productDesignTabsLoaded = true;
  function initialize(root) {
    root.querySelectorAll('[data-product-design-tabs]').forEach(shell => {
      if (shell.dataset.ready) return;
      const main = shell.querySelector('.product-design-tabs__main');
      const nav = shell.querySelector('[role="tablist"]');
      const description = main.querySelector('[data-design-description]');
      const source = main.querySelector('[data-design-details]');
      const sections = [];
      if (description) sections.push({ title: description.dataset.title, nodes: [description] });
      const rich = source.querySelector(':scope > .metafield-rich_text_field') || source;
      let current;
      [...rich.childNodes].forEach(node => {
        if (node.nodeType === 1 && node.tagName === 'H3') {
          current = { title: node.textContent.trim(), nodes: [] };
          sections.push(current);
        } else if (current) {
          current.nodes.push(node);
        } else if (node.textContent.trim() || node.nodeType === 1) {
          if (!sections.length) sections.push({ title: nav.getAttribute('aria-label'), nodes: [] });
          sections[0].nodes.push(node);
        }
      });
      if (!sections.length) return;
      let active = 0;
      const mobile = window.matchMedia('(max-width: 749px)');
      const items = sections.map((section, index) => {
        const item = document.createElement('details');
        item.className = 'product-design-tabs__item';
        item.id = `${shell.id}-panel-${index}`;
        const summary = document.createElement('summary');
        summary.textContent = section.title;
        const body = document.createElement('div');
        body.className = 'product-design-tabs__content rte';
        section.nodes.forEach(node => body.append(node));
        item.append(summary, body);
        main.append(item);
        const button = document.createElement('button');
        button.type = 'button';
        button.id = `${shell.id}-tab-${index}`;
        button.className = 'product-design-tabs__button';
        button.setAttribute('role', 'tab');
        button.setAttribute('aria-controls', item.id);
        button.textContent = section.title;
        nav.append(button);
        button.addEventListener('click', () => activate(index));
        button.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % sections.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + sections.length) % sections.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = sections.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          activate(next);
          items[next].button.focus();
        });
        item.addEventListener('toggle', () => {
          if (mobile.matches && item.open) {
            active = index;
            items.forEach(other => { if (other.item !== item) other.item.open = false; });
          }
        });
        return { item, button, summary };
      });
      source.remove();
      function activate(index) {
        active = index;
        items.forEach(({ item, button }, i) => {
          button.setAttribute('aria-selected', String(i === active));
          button.tabIndex = i === active ? 0 : -1;
          if (mobile.matches) {
            item.hidden = false;
            item.removeAttribute('role');
            item.removeAttribute('aria-labelledby');
            item.removeAttribute('tabindex');
            item.open = i === active;
          } else {
            item.open = true;
            item.hidden = i !== active;
            item.setAttribute('role', 'tabpanel');
            item.setAttribute('aria-labelledby', button.id);
            item.tabIndex = 0;
          }
        });
        if (!mobile.matches) {
          const button = items[active].button;
          const left = button.offsetLeft - nav.offsetLeft;
          if (left < nav.scrollLeft) nav.scrollLeft = left;
          else if (left + button.offsetWidth > nav.scrollLeft + nav.clientWidth) nav.scrollLeft = left + button.offsetWidth - nav.clientWidth;
        }
      }
      function layout() {
        nav.hidden = mobile.matches;
        activate(active);
      }
      shell.dataset.ready = 'true';
      layout();
      mobile.addEventListener('change', layout);
      function cleanup(event) {
        if (!event.target.contains(shell)) return;
        mobile.removeEventListener('change', layout);
        document.removeEventListener('shopify:section:unload', cleanup);
      }
      document.addEventListener('shopify:section:unload', cleanup);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
